<template>
  <div class="hello container">

    <p>If you have benefited from using FiBar, please, consider citing the following paper.</p>

    <p>
Moor M., Männaste L., Putrinš M., Fishman D., Kogermann K.
<br>
<b>FiBar: A tool for analyzing fiber diameters in complex drug delivery systems from scanning electron microscopy images</b>

</p>

<textarea wrap="off" class="form-control" rows="10">
@article{MOOR2025107179,
title = {FiBar: A tool for analyzing fiber diameters in complex drug delivery systems from scanning electron microscopy images},
journal = {European Journal of Pharmaceutical Sciences},
volume = {212},
pages = {107179},
year = {2025},
issn = {0928-0987},
doi = {https://doi.org/10.1016/j.ejps.2025.107179},
url = {https://www.sciencedirect.com/science/article/pii/S0928098725001782},
author = {Marilin Moor and Laura Männaste and Marta Putrinš and Dmytro Fishman and Karin Kogermann},}
</textarea>
  </div>
</template>

<script>
export default {
  name: 'About',
}
</script>

<style scoped>

</style>        
